import httpClient from '@utils/httpClient.js';

export function updateImageApiCall(options) {
  const { id, img, url, isFullWidth, aspectRatio } = options;

  const profileId = localStorage.getItem('unilinkProfileId');

  return httpClient.put(`api/profiles/${profileId}/email-marketing/block/image`, {
    id,
    image: img,
    url,
    isFullWidth: isFullWidth,
    aspectRatio: aspectRatio,
  });
}
